import { Input } from 'components/elements'
import { Field } from 'formik'
import styled from 'styled-components'

const defaultProps = {}
const propTypes = {}

const StyledInput = styled(Input)``

export const FormInput = ({
  name,
  validate,
  required,
  helperText,
  ...rest
}) => {
  const inputValidation = value => {
    if (!validate) {
      return required && !value && 'Required field'
    } else {
      return validate(value)
    }
  }

  return (
    <Field name={name} validate={inputValidation}>
      {({ field, form }) => (
        <StyledInput
          id={name}
          {...field}
          fullWidth
          onChange={form.handleChange}
          error={form.touched[name] && Boolean(form.errors[name])}
          helperText={(form.touched[name] && form.errors[name]) || helperText}
          disabled={form.isSubmitting}
          {...rest}
        />
      )}
    </Field>
  )
}

Input.defaultProps = defaultProps
FormInput.propTypes = propTypes

export default FormInput
